import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for promotional codes table.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in nested functions
        var vthis = this;
        return {
            // Define the layout structure with rows
            rows: [
                {
                    // Unique identifier for the preloader component
                    id: 'preloader',
                    cols: [
                        {
                            // Define a datatable view
                            view: 'datatable',
                            // Unique identifier for the datatable
                            id: 'datatable',
                            // CSS classes for styling the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            // Enable row selection
                            select: true,
                            // Set height based on screen width
                            height: screen.width < 500 ? 400 : 0,
                            // Define the columns of the datatable
                            columns: [
                                {
                                    // Unique identifier for the rating column
                                    id: 'rating',
                                    // Header for the column (empty in this case)
                                    header: '',
                                    // Width of the column
                                    width: 50,
                                    // Height of the column
                                    height: 25,
                                    // Tooltip text for the column
                                    tooltip: _('Editar'),
                                    // Template function to render the column content
                                    template: function (obj) {
                                        // Check if the user has permission to edit
                                        if (devConfig.getPermAction('agentReportsPromotionalCodesEdit', 'Edit')) {
                                            // Return edit icon if permission is granted
                                            return "<span class='webix_icon wxi-close edit'></span>";
                                        } else {
                                            // Return empty string if permission is denied
                                            return '';
                                        }
                                    },
                                },
                                {
                                    // Unique identifier for the ID column
                                    id: 'Id',
                                    // Header for the column
                                    header: 'ID',
                                    // Width of the column
                                    width: 100,
                                    // Sort type for the column
                                    sort: 'int',
                                },
                                {
                                    // Unique identifier for the Code column
                                    id: 'Code',
                                    // Header for the column with localization
                                    header: _('Código'),
                                    // Width of the column
                                    width: 250,
                                    // Sort type for the column
                                    sort: 'int',
                                },
                                {
                                    // Unique identifier for the CreatedLocalDate column
                                    id: 'CreatedLocalDate',
                                    // Header for the column with localization
                                    header: _('Fecha de Creación'),
                                    // Fill space option for responsive design
                                    fillspace: 0,
                                    // Minimum width of the column
                                    minWidth: 0,
                                    // Width of the column
                                    width: 150,
                                    // Sort type for the column
                                    sort: 'text',
                                    // Format function for date display
                                    format: dateFormat,
                                },
                                {
                                    // Unique identifier for the LinkId column
                                    id: 'LinkId',
                                    // Header for the column with localization
                                    header: _('LinkId'),
                                    // Width of the column
                                    width: 250,
                                    // Sort type for the column
                                    sort: 'int',
                                },
                                {
                                    // Unique identifier for the IsActivate column
                                    id: 'IsActivate',
                                    // Header for the column with localization
                                    header: _('Estado'),
                                    // Options for the dropdown in the column
                                    options: [
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    // Width of the column
                                    width: 150,
                                    // Sort type for the column
                                    sort: 'int',
                                },
                            ],
                            // Event handler for click events on the datatable
                            onClick: {
                                // Function to handle edit icon clicks
                                edit: function (euv, id) {
                                    // Show the edit code dialog
                                    $$('EditCode').show();
                                },
                            },
                            // Enable tooltips for the datatable
                            tooltip: true,
                            // Enable math calculations in the datatable
                            math: true,
                            // Set the loadahead option for data fetching
                            loadahead: 0,
                            // Set the default data fetch size
                            datafetch: devConfig.getDefaultDataFetch(),
                            // Identifier for the pager component
                            pager: 'pagerA',
                            // Initial data for the datatable
                            data: [
                                {
                                    // Data entry for ID
                                    Id: '01',
                                    // Data entry for Code
                                    Code: '0101',
                                    // Data entry for CreatedLocalDate
                                    CreatedLocalDate: '2019-02-03',
                                    // Data entry for ModifiedLocalDate
                                    ModifiedLocalDate: '2019-02-06',
                                    // Data entry for LinkId
                                    LinkId: '0105',
                                    // Data entry for IsActivate status
                                    IsActivate: 'A',
                                },
                                {
                                    // Data entry for ID
                                    Id: '02',
                                    // Data entry for Code
                                    Code: '0103',
                                    // Data entry for CreatedLocalDate
                                    CreatedLocalDate: '2019-02-10',
                                    // Data entry for ModifiedLocalDate
                                    ModifiedLocalDate: '2019-02-12',
                                    // Data entry for LinkId
                                    LinkId: '0106',
                                    // Data entry for IsActivate status
                                    IsActivate: 'A',
                                },
                            ],
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Reference to the data table component
        grid = $$('datatable');
        // Get the current user ID from parameters
        const cur_user = this.getParam('user', true);
        // Construct the API URL for fetching promotional codes
        var url = devConfig.geturlApi() + 'es/PromotionalCodes/GetCodes?FromId=' + cur_user + '&';
        // Initialize filter string
        var filter = '';
        // Event listener for promotional codes filtering
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            // Convert filter data object to an array of entries
            var object = Object.entries(filterData);
            // Initialize string to build query parameters
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range selection
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle other filter types
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Handle single date selection
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle filter values that are objects
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear existing data in the grid
            grid.clearAll();
            // Load new data into the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    filter + // Additional filter parameters
                    '&sort[' +
                    by + // Sort by the specified column
                    ']=' +
                    dir, // Sort direction (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item based on its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    '&PlayerId=' +
                    Id, // Filter by the selected player's ID
            );
        });
        // Create a popup window for editing promotional codes
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditCode', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Código') }, // Label for the window title
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Hide the window when the icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'editForm', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only field for ID
                    { view: 'text', label: _('Código'), name: 'Code' }, // Input field for code
                    {
                        view: 'text', // Field for creation date
                        label: _('Fecha de Creación'),
                        labelWidth: 140, // Width of the label
                        name: 'CreatedLocalDate',
                        readonly: true, // Read-only field for creation date
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // Input field for LinkId
                    {
                        view: 'combo', // Dropdown for status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated status
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated status
                        ],
                    },
                    {
                        cols: [
                            // Button layout in columns
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    // Hide the window and reset form values on cancel
                                    this.getTopParentView().hide();
                                    $$('editForm').setValues($$('editForm').getCleanValues());
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type for form submission
                                value: _('Guardar'),
                                click: function ($e) {
                                    // Get form values for submission
                                    var values = $$('editForm').getValues();
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for updating code
                                                'PromotionalCodes/UpdateCode',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}', // JSON string with form data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Handle error response
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Handle successful response
                                                    webix.message(_('Código Actualizado'));
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values after submission
                                    );
                                    this.getTopParentView().hide(); // Hide the window after submission
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a local date string in the format YYYY:MM:DD
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Initialize a popup window for adding a new code
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddCode', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Añadir Código') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Hide the window when the close icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'addform', // Unique identifier for the form
                elements: [
                    { view: 'text', label: _('Código'), name: 'Code' }, // Input for the code
                    {
                        view: 'text', // Input for the creation date
                        label: _('Fecha de Creación'),
                        labelWidth: 140, // Width of the label
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set the value to the created local date
                        readonly: true, // Make the input read-only
                    },
                    { view: 'text', label: _('LinkId'), name: 'LinkId' }, // Input for the LinkId
                    {
                        view: 'combo', // Dropdown for the status
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated status
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated status
                        ],
                    },
                    {
                        cols: [
                            // Button layout in columns
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    // Hide the window and reset the form values on cancel
                                    this.getTopParentView().hide();
                                    $$('addform').setValues($$('addform').getCleanValues());
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    // Get form values and send them to the server
                                    var values = $$('addform').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/AddCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                createdLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Show error message on failure
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Show success message and refresh the grid on success
                                                    webix.message(_('Código Agregado'));
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload the grid with new data
                                                    );
                                                },
                                            },
                                        );
                                    // Reset the form values and hide the window after saving
                                    $$('addform').setValues($$('addform').getCleanValues());
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Event listener for the 'addCode:button' event on the app instance
        // When the event is triggered, the popupAdd component is displayed
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show the popup for adding code
        });

        // Binding the editForm to the datatable for data manipulation
        $$('editForm').bind($$('datatable')); // Establishes a connection between the form and the data table // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
